// add-payment-modal.js
(({ $, $$ }) => {
    const modalOpenedClass = 'modal-add-payment_opened'
    const modal = $('.modal-add-payment')

    if (!modal) { return }

    const openers = $$('.lead-payment-all__mobile-add-form-button')
    const closers = $$('.modal-add-payment__closer')

    CNS.$fns.openModalAddPayment = function() {
        modal.classList.add(modalOpenedClass)
    }

    CNS.$fns.closeModalAddPayment = function() {
        modal.classList.remove(modalOpenedClass)
    }

    openers.forEach(opener => {
        opener.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.openModalAddPayment()
        })
    })

    closers.forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalAddPayment()
        })
    })
})(CNS);